/*
From rs-product-customize.liquid we receive:
- totalOptions: With the total number of options for product builder
- totalVariants: With the total number of product variants
*/

var finalProduct = [];

$(document).ready(function() {
  if (totalOptions > 0 && countShowInProductPage == 0){
    // Hide the stock section and only show customize
    $('#btnInStock').hide();
    $('#regionInStock').hide();
    $('#btnCustomize').hide();
    $("button[name='addToCartButton'").hide();
    $('#regionCustomize').show();
  }

  if(countShowInProductPage >= 1){
    $('#regionInStock').show();
    if(totalOptions > 0){
      $('#btnCustomize').show();
    }
  }

  if(askForPrice){
    $('#btnInStock').hide();
    $('#regionInStock').hide();
    $('#btnCustomize').hide();
    $('#regionCustomize').hide();
    $("button[name='addToCartButton'").hide();
    $("#rs-product-price").hide();
  }

  if(redirectUrl && redirectUrl.includes("http")){
    $('#btnRedirect').show();
  }
});

$(".customize-select-options").click(function() {
  $(this).addClass("border-select-product");
  $(this).parent().find('.customize-select-options').not(this).removeClass('border-select-product');
});

$('#rs-presenter-modal-close').on('click', function(){
    $('body').css("overflow", "auto");
    $('#rs-presenter-modal').hide();
});

$('#rs-presenter-modal-open').on('click', function(){
    $('body').css("overflow", "hidden");
  	$('#rs-presenter-modal').appendTo(document.body);
    $('#rs-presenter-modal').show();
});

$('#rs-builder-modal-close').on('click', function(){
    $('body').css("overflow", "auto");
    $('#rs-builder-modal').hide();
});

$('#rs-builder-modal-open').on('click', function(){
    $('body').css("overflow", "hidden");
  	$('#rs-builder-modal').appendTo(document.body);
    $('#rs-builder-modal').show();
});

$('#btnCustomize').on('click', function() {
  $('#btnInStock').show();
  $('#regionInStock').hide();
  $('#btnCustomize').hide();
  $("button[name='addToCartButton'").hide();
  $('#regionCustomize').show();
});

$('#btnInStock').on('click', function() {
  $('#btnInStock').hide();
  $('#regionInStock').show();
  $('#btnCustomize').show();
  $('#regionCustomize').hide();
  $("button[name='addToCartButton'").show();
});
